import Drawer from "../../drawer/Drawer.jsx";
import CustomButton from "../../kits/custom-button/CustomButton.tsx";
import colorSchema from "../../../assets/kits/colors";

import { addCommas, removeCommas } from "@persian-tools/persian-tools";

export default function WalletDrawer({ isOpen, setIsOpen }) {
  return (
    <>
      <Drawer
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
        height={280}
      >
        <div className="pd-16 ">
          <h6 className="title-h3-b" style={{ color: colorSchema.gray_900 }}>
            کیف پول و پرداختی
          </h6>
          <div className="d-flex justify-content-between align-items-center mr-t-16">
            <div>
              <div className="title-h4-m" style={{ color: "black" }}>
                موجودی کیف پول
              </div>
              <div className="txt-t2-l mr-t-4" style={{ color: "black" }}>
                {addCommas(12900100)} تومان
              </div>
            </div>
            <div>
              <CustomButton buttonStyle="secondary" size="small">
                درخواست تسویه
              </CustomButton>
            </div>
          </div>
          <hr className="mr-y-16" style={{ color: "#4b5563" }} />
          <div className="d-flex justify-content-between align-items-center mr-t-16">
            <div>
              <div className="title-h4-m" style={{ color: "black" }}>
                تراکنش های شما
              </div>
              <div className="txt-t2-l mr-t-4" style={{ color: "black" }}>
                برای دانلود روی دکمه بزنید
              </div>
            </div>
            <div>
              <CustomButton buttonStyle="secondary" size="small">
                درخواست دانلود
              </CustomButton>
            </div>
          </div>
          <div className="pd-t-16">
            <CustomButton size="large" className="w-100">
              تایید
            </CustomButton>
          </div>
        </div>
      </Drawer>
    </>
  );
}
